import { CurrencyEnum } from '@systemeio/ui'
import { COUPONS_API } from 'modules/coupons/api/coupon-api'
import { CouponInterface } from 'modules/coupons/types/coupon-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'

export function useCustomerCoupons(currency: CurrencyEnum, shouldFetch?: boolean) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, CouponInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: coupons, mutate: mutateCoupons } = useSWR(() => {
    if (shouldFetch) {
      return `${COUPONS_API}/list-by-currency/${currency}`
    }
    return null
  }, fetcher)

  return { coupons, mutateCoupons }
}
